
const tools = {
	/* 判断设备是否为移动端 */
	isMobile() {
		return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Opera Mini|Opera Mobile|Chrome Mobile|Samsung|Mobile.+Safari)/i.test(
			navigator.userAgent
		);
	},


	/* 深拷贝对象 */
	deepClone(obj) {
		let objType = tools.getVariableType(obj);
		let result;
		if (objType === "Object") result = {};
		if (objType === "Array") result = [];
		if (!result) return obj;
		for (let k in obj) {
			if (obj.hasOwnProperty(k)) {
				let child = obj[k];
				let childType = tools.getVariableType(child);
				let needDeepClone = childType === "Object" || childType === "Array";
				if (needDeepClone) {
					result[k] = tools.deepClone(child);
				} else {
					result[k] = child;
				}
			}
		}
		return result;
	},

	/* 防抖函数 */
	debounce(func, delay) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				func(...args);
			}, delay);
		};
	},

	/* 节流函数 */
	throttle(func, limit) {
		let lastFunc;
		let lastRan;

		return (...args) => {
			if (!lastRan) {
				func(...args);
				lastRan = Date.now();
			} else {
				clearTimeout(lastFunc);
				lastFunc = setTimeout(() => {
					if (Date.now() - lastRan >= limit) {
						func(...args);
						lastRan = Date.now();
					}
				}, limit - (Date.now() - lastRan));
			}
		};
	},

	/* 获取设备信息 */
	getDeviceInfo() {
		const userAgent = navigator.userAgent.toLowerCase();

		// 定义浏览器检测的模式
		const browsers = [
			{ name: "WeChat Browser", pattern: /micromessenger\/([\d.]+)/ },
			{ name: "Chrome", pattern: /(?:chrome|crios)\/([\d.]+)/ },
			{ name: "Firefox", pattern: /(?:firefox|fxios)\/([\d.]+)/ },
			{ name: "Safari", pattern: /version\/([\d.]+).*safari/ },
			{ name: "Internet Explorer", pattern: /msie\s([\d.]+)/ },
			{ name: "Edge", pattern: /edge\/([\d.]+)/ },
			{ name: "Opera", pattern: /(?:opera|opr)\/([\d.]+)/ },
			{ name: "QQ Browser", pattern: /qqbrowser\/([\d.]+)/ },
			{ name: "UC Browser", pattern: /ucbrowser\/([\d.]+)/ },
			{ name: "Quark Browser", pattern: /quark\/([\d.]+)/ },
			{ name: "Google App Browser", pattern: /GNews\/([\d.]+)/ }
		];

		// 判断操作系统
		const isWindows = /windows/i.test(userAgent);
		const isMac = /macintosh/i.test(userAgent);
		const isAndroid = /android/i.test(userAgent);
		const isIOS = /iphone|ipod|ipad/i.test(userAgent);

		// 判断设备类型：移动端或PC端
		const isMobile = /mobile/i.test(userAgent); // 匹配移动端设备
		const isPC = !isMobile; // 非移动端即为PC端

		// 是否是微信环境
		const isWeChat = /micromessenger/i.test(userAgent);

		// 是否为微信小程序环境
		const isWxMiniProgram = /miniprogram/i.test(userAgent);

		// 初始化浏览器名称和版本为未知
		let browserName = "Unknown";
		let browserVersion = "Unknown";

		// 遍历浏览器检测数组
		for (const browser of browsers) {
			const match = userAgent.match(browser.pattern);
			if (match) {
				browserName = browser.name;
				browserVersion = match[1]; // 获取浏览器版本
				break;
			}
		}

		// 获取客户端版本号和设备名称（通过第一个括号内的内容）
		let clientVersion = "Unknown";
		let clientName = "Unknown";

		// 提取第一个括号内的内容
		const bracketMatch = userAgent.match(/\((.*?)\)/);
		if (bracketMatch) {
			const deviceInfo = bracketMatch[1];

			if (isAndroid) {
				// 提取 Android 版本号
				const androidVersionMatch = deviceInfo.match(/android\s([0-9\.]+)/);
				if (androidVersionMatch) {
					clientVersion = androidVersionMatch[1];
				}
				// 设置 clientName 为 Android
				clientName = "Android";
			} else if (isIOS) {
				// 提取 iOS 版本号
				const iosVersionMatch = deviceInfo.match(/os\s([0-9_]+)/);
				if (iosVersionMatch) {
					clientVersion = iosVersionMatch[1].replace(/_/g, ".");
				}
				// 设置 clientName 为 iOS
				clientName = "iOS";
			} else if (isWindows) {
				// 提取 Windows 版本号
				const windowsMatch = deviceInfo.match(/windows nt\s([0-9\.]+)/);
				if (windowsMatch) {
					clientVersion = windowsMatch[1];
				}
				clientName = "Windows";
			} else if (isMac) {
				// 提取 macOS 版本号
				const macMatch = deviceInfo.match(/mac os x\s([0-9_]+)/);
				if (macMatch) {
					clientVersion = macMatch[1].replace(/_/g, ".");
				}
				clientName = "Macintosh";
			}
		}

		// 获取客户端信息
		const clientInfo = {
			userAgent: navigator.userAgent, // User-Agent 字符串
			clientVersion: clientVersion, // 客户端版本号
			clientName: clientName // 客户端设备名称
		};

		return {
			isMobile, // 是否为移动端
			isPC, // 是否为PC端
			isWindows, // 是否是Windows系统
			isMac, // 是否是Mac系统
			isAndroid, // 是否是Android系统
			isIOS, // 是否是iOS系统
			isWeChat, // 是否是微信环境
			isWxMiniProgram, // 是否为微信小程序环境
			browserName, // 浏览器名称
			browserVersion, // 浏览器版本
			clientInfo // 客户端详细信息
		};
	},

	/* 微信环境播放 */
	onBridgeReady(playCallback) {
		//必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
		if (window.WeixinJSBridge) {
			WeixinJSBridge.invoke(
				"getNetworkType",
				{},
				function (e) {
					playCallback();
				},
				false
			);
		} else {
			document.addEventListener(
				"WeixinJSBridgeReady",
				function () {
					WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
						playCallback();
					});
				},
				false
			);
		}
	}
};

export default tools;



// WEBPACK FOOTER //
// ./src/utils/tools.js